// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gm-a";
export var fulfillmentFormRail = "_gm-9";
export var headerTitleRow = "_gm-c";
export var orderDetailsWrapper = "_gm-7";
export var orderLinkTrigger = "_gm-2";
export var paymentInformationGrid = "_gm-h";
export var paymentSummaryColumn = "_gm-i";
export var shipmentContainer = "_gm-b";
export var shipmentDetailsMainPane = "_gm-8";
export var shipmentNavigationCard = "_gm-5";
export var shipmentNavigationRail = "_gm-3";
export var shipmentNavigationRailHeader = "_gm-4";
export var shipmentSummaryFact = "_gm-e";
export var shipmentSummaryGrid = "_gm-d";
export var shipmentSummaryMetadataRow = "_gm-f";
export var shipmentSummaryTags = "_gm-g";
export var shipmentWorkspace = "_gm-0";
export var shipmentWorkspaceContent = "_gm-6";
export var shipmentWorkspaceHeader = "_gm-1";